import { render, staticRenderFns } from "./points-redeem-confirm.vue?vue&type=template&id=00de540a"
import script from "./points-redeem-confirm.vue?vue&type=script&lang=js"
export * from "./points-redeem-confirm.vue?vue&type=script&lang=js"
import style0 from "./points-redeem-confirm.vue?vue&type=style&index=0&id=00de540a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports